<template>
  <v-menu>
    <template #activator="{ on }">
      <v-btn icon :disabled="!visibleActions.length" v-on="on">
        <v-icon class="white--text">
          more_vert
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(action, index) in visibleActions" :key="`action-item-${index}`" :disabled="action.disabled" @click="action.method()">
        <v-list-item-content>
          <v-list-item-title>{{ action.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    actions: { type: Array, default: () => [] }
  },
  computed: {
    visibleActions() {
      return this.actions.filter(a => !a.hidden)
    }
  }
}
</script>
